import { render, staticRenderFns } from "./get-single-product.vue?vue&type=template&id=e4619c00&"
import script from "./get-single-product.vue?vue&type=script&lang=js&"
export * from "./get-single-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports